import i18n from 'i18n';
import { Formik } from 'formik';
import { Redirect } from 'react-router-dom';
import { LoadingIndicator } from 'components/LoadingIndicator';
import { Page } from 'components/Page/Page';
import { RevenueSharingFormContent } from './RevenueSharingFormContent';
import { useRevenueSharingFormModel } from './useRevenueSharingFormModel';

export const RevenueSharingForm: React.FC = () => {

  const {
    loading,
    redirect,
    initRevenueSharing,
    getOriginalPercentageText,
    validateForm,
    onSubmit
  } = useRevenueSharingFormModel();

  if (redirect) {
    return <Redirect to={redirect} />;
  }

  return (
    <Page title={i18n.t<string>('revenueSharingForm.titles.create')} spaceBetweenTopAreaAndContent={false}>
      {loading && <LoadingIndicator />}
      <Formik
        initialValues={initRevenueSharing}
        onSubmit={onSubmit}
        validate={validateForm}
        validateOnBlur={false}
        enableReinitialize
      >
        <RevenueSharingFormContent getOriginalPercentageText={getOriginalPercentageText} />
      </Formik>
    </Page>
  );
};
